import { render, staticRenderFns } from "./DetailModifyManage.vue?vue&type=template&id=50ab1164&scoped=true"
import script from "./DetailModifyManage.vue?vue&type=script&lang=js"
export * from "./DetailModifyManage.vue?vue&type=script&lang=js"
import style0 from "./DetailModifyManage.vue?vue&type=style&index=0&id=50ab1164&prod&lang=css"
import style1 from "./DetailModifyManage.vue?vue&type=style&index=1&id=50ab1164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab1164",
  null
  
)

export default component.exports